import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateMyOrganization } from '../api/auth.api';

import { AUTH_KEYS } from './useCurrentUser';

// Invalidating AUTH_KEYS.me is what refreshes useCurrentUser()'s cached /auth/me data after the
// login gate saves, so OrganizationGateDialog clears without a full page reload.
export function useUpdateMyOrganization() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateMyOrganization,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: AUTH_KEYS.me }),
  });
}
